import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=4d6e8720&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=4d6e8720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6e8720",
  null
  
)

export default component.exports